export function openFaq(id: number) {
  const myEvent = new CustomEvent('openSupportModuleFaq', { detail: { id } });
  document.dispatchEvent(myEvent);
}
